/**
 * STO-354/STO-359 — a decisão pura de avisar (ou não) pelo sistema operacional.
 *
 * Verdadeira só quando as três condições valem ao mesmo tempo: o aparelho
 * suporta a via (`ServiceWorkerRegistration.showNotification`), a permissão já
 * foi concedida, e a aba está escondida. "O sino é ferramenta, não interrupção"
 * (`connectionStore.ts`) — com a página visível o usuário já vê o sino acender
 * e não deve levar um banner do SO por cima.
 */
export interface EntradaDeAviso {
  visibilityState: DocumentVisibilityState
  permissao: NotificationPermission
  /** `false` quando o navegador não tem service worker ou Notification. */
  suporta: boolean
}

export function deveAvisarForaDaTela(entrada: EntradaDeAviso): boolean {
  return (
    entrada.suporta && entrada.permissao === 'granted' && entrada.visibilityState === 'hidden'
  )
}
